const ResourceTypesEnum = Object.freeze({
  APPLICATION_RULES: 1,
  DEVICES: 2,
  ENVIRONMENTS: 3,
  USERS: 5,
  VPN_CERTIFICATE: 9,
  VPN_PROFILES: 10,
  VERSIONS_MANAGEMENT: 11,
  DEVICES_IMPORT: 12,
  DEVICE_CERTIFICATE: 14
});

const ActionTypesEnum = Object.freeze({
  CREATE: 1,
  UPDATE: 2,
  DELETE: 3,
  ENABLE: 4,
  DISABLE: 5
});

export { ResourceTypesEnum, ActionTypesEnum };
